import styled from 'styled-components';

export const ManualBroadcastStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  .input-block {
    .input-label {
      display: flex;
      flex-direction: column;
      gap: 4px;
      font-size: 14px;
      font-weight: 500;
      line-height: 20px;
      color: ${({ theme }) => theme.colors.gray[50]};
    }

    &.group {
      display: grid;
      grid-template-columns: 440px auto;
      grid-gap: 8px;
    }
  }
`;
